// extracted by mini-css-extract-plugin
export default {"scrollBtn":"BtnScrollUp_scrollBtn__AkLH1","arrow":"BtnScrollUp_arrow__UFj5g"};